import BossModel from "@/models/BossModel";

export default class TaskAction extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'task/action';

    /**
     *
     * @type {string}
     */
    static entity = 'taskTaskActions';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			is_active: this.attr(null),
		}
	}

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).where('is_active', true).get(true);
    }

    /**
     *
     * @returns {*}
     */
    static loadAll(){
        return this.api().limit(0).get(true);
    }
}
